import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

import { Exclude, Expose, Type } from 'class-transformer';
import { ContractorPaymentTypeEnum } from '../../contractor/enums/contractor-payment-type.enum';
import { JobOriginalSupervisorInterface } from '../interfaces/job-original-supervisor.interface';
import { UserDto } from '../../user/dto/user.dto';
import { JobDto } from '../../job/dto/job.dto';

@Exclude()
export class JobOriginalSupervisorDto
  implements JobOriginalSupervisorInterface
{
  @ApiProperty({
    title: 'UserID',
  })
  @Expose()
  userId!: string;

  @ApiPropertyOptional({
    type: () => [UserDto],
    title: 'Job Repair Photos',
    description: 'The Job Repairs Photos associated with this job repair ',
  })
  @Expose()
  user?: UserDto;

  @ApiProperty({
    title: 'Id',
  })
  @Expose()
  id!: string;

  @ApiProperty({
    type: 'date-time',
    title: 'Created At',
  })
  @Expose()
  @Type(() => Date)
  createdAt!: Date;
  @ApiProperty({
    type: 'date-time',
    title: 'Created At',
  })
  @Expose()
  @Type(() => Date)
  updatedAt!: Date;

  @ApiProperty({
    title: 'JobId',
  })
  @Expose()
  jobId!: string;

  @ApiPropertyOptional({
    type: () => [JobDto],
    title: 'Job',
    description: 'Job',
  })
  @Expose()
  job?: JobDto;
}
